var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McLayoutForm',[(_vm.$route.params.action === 'reset')?_c('h2',[_vm._v(_vm._s(_vm.$t('resetform.resetPassword')))]):_vm._e(),(_vm.$route.params.action === 'choose')?_c('h2',[_vm._v(_vm._s(_vm.$t('resetform.choosePassword')))]):_vm._e(),(_vm.$route.params.token)?_c('ResetPasswordStep2Form'):_c('ResetPasswordForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }